var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useField } from 'formik';
import React from 'react';
import styled from 'styled-components';
import { Grid, TextField, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
const StyledGrid = styled(Grid) `
  display: flex;
  flex-direction: column;
  .select-field {
    margin-right: 22px;
  }
`;
export const FormikTextField = props => {
    let { variant, type } = props;
    let { name, grid, helperText } = props, textFieldProps = __rest(props, ["name", "grid", "helperText"]);
    const [field, meta] = useField(name);
    const [showPassword, setShowPassword] = React.useState(false);
    if (!grid) {
        // default field to expand entire width of form
        grid = { xs: 12 };
    }
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    return (React.createElement(StyledGrid, Object.assign({ item: true, className: 'formik-text-field' }, grid),
        React.createElement(TextField, Object.assign({}, textFieldProps, { variant: variant || 'outlined', autoComplete: 'off', error: meta.touched && Boolean(meta.error), helperText: meta.error || helperText, type: type === 'password' ? (showPassword ? 'text' : 'password') : type, InputProps: {
                endAdornment: (React.createElement(React.Fragment, null, type === 'password' ? (React.createElement(IconButton, { onClick: handleClickShowPassword, onMouseDown: handleMouseDownPassword, edge: 'end' }, showPassword ? React.createElement(Visibility, null) : React.createElement(VisibilityOff, null))) : null))
            } }, field, { name: name }))));
};
export default FormikTextField;
//# sourceMappingURL=FormikTextField.js.map